const MaterialIcon = ({
  wrapperClassName = "",
  iconClassName = "",
  iconName = "",
  click = () => {},
  children = null,
}) => {
  const onClick = () => {
    if (click) {
      click();
    }
  };
  return (
    <div className={`${wrapperClassName}`} onClick={onClick}>
      <span className={`material-icons vertical-middle ${iconClassName}`}>
        {iconName}
      </span>
      {children}
    </div>
  );
};

export default MaterialIcon;
